import { CommonModule } from '@angular/common';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { IconSearchAutocompleteModule } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.module';
import * as i0 from "@angular/core";
export class QuickflowsMenuModule {
}
QuickflowsMenuModule.ɵfac = function QuickflowsMenuModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || QuickflowsMenuModule)(); };
QuickflowsMenuModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: QuickflowsMenuModule });
QuickflowsMenuModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, IconModule, IconSearchAutocompleteModule, TooltipModule] });
